module.exports = __webpack_public_path__ + "img/de.5e088521.svg";